// extracted by mini-css-extract-plugin
export default {"entityItemButton":"SidebarEntityItem_entityItemButton__K07D6","entityItemButtonActive":"SidebarEntityItem_entityItemButtonActive__MeTN+"};